<template>
<span class="h-full w-full">
  <el-select  v-if="modifiable" ref="selectEditor"  v-model="editing.value" :filterable="filterable" :allow-create="allowcreate" :placeholder="placeholder" default-first-option
  @change="selected" controls-position="right" size="mini">
    <el-option v-for="option in optionList" :key="getOptionKey(option)" :label="option[labelprop]" :value="option[property]">
    </el-option>
  </el-select>
  <span v-else > {{getValueCheckEmpty(selectValue)}} </span>
</span>
</template>

<script>
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import Editingf from '@/mixins/editingForm';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WSelectForm',
  // modifiable = 수정필드 사용 여부
  // target = Form에 바인딩된 Json객체
  //
  // ** el-select props
  // placeholder
  //
  // ** el-option props
  // optionList = el-option 사용될 옵션 배열
  // optionKey = unique key값 (다중 키 가능 : 다중키의 경우 ','로 key값을 나누어 전달)
  // property = value 로 사용될 Key 값
  // labelprop = label로 사용될 key 값
  props: ['modifiable', 'target', 'emptyText', 'optionList', 'optionKey', 'property', 'labelprop', 'search', 'selfinput'],
  mixins: [Editingf],
  data() {
    return {
      selectValue: null,
    };
  },
  computed: {
    baseProperty() {
      return this.target[this.property];
    },
    filterable() {
      return this.search ? this.search === 'true' : false;
    },
    allowcreate() {
      return this.selfinput ? this.selfinput === 'true' : false;
    },
    placeholder() {
      return this.emptyText ? this.emptyText : '선택해주세요.';
    },
  },
  watch: {
    target: {
      handler() {
        // select 객체는 id값을 기반으로 value를 보여주기 떄문에
        // 수정모드가 아닐 경우 보여줄 값 필요
        //
        // optionList에 있는 경우 el-option Label 에 설정된 값을 보여줌
        //             없는 경우 slot에 전달된 값 그대로 보여줌
        if (!isNil(this.target)) {
          if (!isNil(this.labelprop) && !isNil(this.target[this.labelprop])) {
            // labelProp에 해당하는 필드가 taget 객체에 있는 경우 바로 해당 필드의 정보를 제공하도록 한다. (ex) objCompanyName
            this.selectValue = this.target[this.labelprop];
          } else {
            const optionValue = this.target[this.property];
            let optionLabel;
            if (!isNil(optionValue) && !isNil(this.optionList) && this.optionList.length > 0) {
              this.optionList.forEach((option) => {
                if (option[this.property] === optionValue) {
                  optionLabel = option[this.labelprop];
                }
              });
              this.selectValue = !isNil(optionLabel) ? optionLabel : optionValue;
            } else if (isNil(optionValue)) {
              this.selectValue = EMPTY_TEXT;
            } else {
              this.selectValue = optionValue;
            }
          }
        }
      },
      immediate: true,
    },
    baseProperty: {
      handler(val, oldVal) {
        // 수정모드 도중 외부 작용에 의해 기존 property 데이터 value가 변경 되었다면 editing값도 맞추어 변경
        if (this.modifiable && this.editing.isEditing && this.baseProperty !== this.editing.value) {
          this.editing.value = this.baseProperty;
          this.updateEdit(this.editing.value);
        }
      },
      deep: true,
    },
    modifiable: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.startEdit(this.target, this.property);
        } else if (!isNil(oldVal)) {
          // 수정 진행 -> 종료 일경우에만
          this.endEdit(this.editing.value);
        }
      },
    },
  },
  methods: {
    getValueCheckEmpty(value) {
      if (isNumber(value) && value < 0) {
        return '-';
      }
      return getValueAfterCheckEmpty(value);
    },
    getOptionKey(raw) {
      let keyValue = '';
      const keys = this.optionKey.split(',');
      if (this.optionKey) {
        keys.forEach((id) => {
          keyValue += raw[id.trim()] + '.';
        });
        keyValue = keyValue.substring(0, keyValue.length - 1);
        return keyValue;
      }
    },
    selected(value) {
      this.updateEdit(value);
      this.$emit('change', value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/formeditor/SelectFormEditor.vue